import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_URL, PagedResponse } from "@edl-development/edl-common";
import { PagedModel } from "src/app/model/common/paged.model";
import { EdlItemPacketDTO } from "src/app/model/item-packet/edl-item-packet-dto.model";
import { EdlItemPacketFormDTO } from "src/app/model/item-packet/edl-item-packet-form-dto.model";
import { EdlItemPacketSummaryDTO } from "src/app/model/item-packet/edl-item-packet-summary-dto.model";
import { ComplyBaseApi } from "../comply/comply-base.api";
import { EdlItemPacketEntryDTO } from "src/app/model/item-packet/edl-item-packet-entry.model";
import { EdlItemPacketUserSummaryDTO } from "src/app/model/item-packet/edl-item-packet-user-summary-dto.model";
import { EdlItemPacketActions } from "src/app/model/enum/item-packet/eld-item-packet-actions.enum";

@Injectable()
export class ItemPacketApi extends ComplyBaseApi {
    private static SUB_ROUTE = 'itemPacket';

    private get route() {
        return `${this.baseUri}/${ItemPacketApi.SUB_ROUTE}`;
    }

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    get(id: string) {
        return this.http.get<EdlItemPacketDTO>(`${this.route}/${id}`);
    }

    getPackets(paging: PagedModel) {
        const params = this.generatePagingParams(paging);

        return this.http.get<PagedResponse<EdlItemPacketSummaryDTO>>(`${this.route}/packets`, {
            params
        });
    }

    getPacketsForUser(userId: string) {
        return this.http.get<EdlItemPacketUserSummaryDTO[]>(`${this.route}/packetsForUser/${userId}`);
    }

    getPacketsForUserSupervisionItems(userId: string) {
        return this.http.get<EdlItemPacketUserSummaryDTO[]>(`${this.route}/packetsForUserSupervisionItems/${userId}`);
    }

    getAllPackets() {
        return this.http.get<EdlItemPacketEntryDTO[]>(`${this.route}/allPackets`);
    }

    getMyPermissions() {
        return this.http.get<EdlItemPacketActions[]>(`${this.route}/myPermissions`);
    }

    create(packet: EdlItemPacketFormDTO) {
        return this.http.post<EdlItemPacketDTO>(`${this.route}/create`, packet);
    }

    save(packet: EdlItemPacketFormDTO) {
        return this.http.put<EdlItemPacketDTO>(`${this.route}/save`, packet);
    }

    publish(packet: EdlItemPacketFormDTO) {
        return this.http.put<EdlItemPacketDTO>(`${this.route}/publish`, packet);
    }

    unpublish(packet: EdlItemPacketFormDTO) {
        return this.http.put<EdlItemPacketDTO>(`${this.route}/unpublish`, packet);
    }

    duplicate(id: string) {
        return this.http.post<EdlItemPacketDTO>(`${this.route}/duplicate/${id}`, {});
    }

    archive(id: string) {
        return this.http.put(`${this.route}/archive/${id}`, {});
    }

    unarchive(id: string) {
        return this.http.put(`${this.route}/unarchive/${id}`, {});
    }

    delete(id: string) {
        return this.http.delete(`${this.route}/delete/${id}`);
    }

    restore(id: string) {
        return this.http.put(`${this.route}/restore/${id}`, {});
    }
}